import { render } from "./PickupAddresses.vue?vue&type=template&id=75694587&scoped=true&ts=true"
import script from "./PickupAddresses.vue?vue&type=script&lang=ts"
export * from "./PickupAddresses.vue?vue&type=script&lang=ts"

import "./PickupAddresses.vue?vue&type=style&index=0&id=75694587&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75694587"]])

export default __exports__